let storeRef = '';

export const setStoreRef = (store) => {
  storeRef = store;
};

export const getStoreRef = () => storeRef;
